
























import Vue from 'vue';
import { HTTP } from '@/utils/httpCommonUtil';
import VueSimpleSpinner from 'vue-simple-spinner';
import { BallPulseLoader } from 'vue-loaders';

export default Vue.component('facility-owner', {
  name: 'FacilityOwner',
  props: {
    'facility-id': {
    },
  },
  data () {
    return {
      loadingModalData: false,
      loadingFacilityOwner: true,
      loadingFacilityOwnerCandidates: false,
      facilityOwner: 'na',
      facilityOwnerCandidates: [],
      showDropdown: false
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader
  },
  mounted: function () {
    this.getFacilityOwner();
  },
  methods: {
    toggleDropdown () {
      this.showDropdown = !this.showDropdown;
      if (this.showDropdown) {
        // Get the nmr employees that have the role permissons to see facilities
        let self = this as any;
        let showOwnerCandidateLoaderTimeout = setTimeout(function () {
          self.loadingFacilityOwnerCandidates = true;
        }, this.facilityOwnerCandidates.length ? 500 : 0);
        HTTP.get('/api/facilities/owner-candidates')
        .then(function (response) {
          clearTimeout(showOwnerCandidateLoaderTimeout);
          self.loadingFacilityOwnerCandidates = false;
          if (!response.data || !response.data.data ) {
            throw new Error("Error retrieving facility owner candidates.");
          }
          self.facilityOwnerCandidates = response.data.data;
        })
        .catch(function (err) {
          console.log(err);
          clearTimeout(showOwnerCandidateLoaderTimeout);
          self.loadingFacilityOwnerCandidates = false;
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: 'An error occurred loading facility owner candidates.'
          });
        })
      }
    },
    getFacilityOwner () {
      let facilityId = (this as any).facilityId;
      let self = this as any;
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingFacilityOwner = true;
      }, 300);
      HTTP.get('/api/facilities/' + facilityId + '/owner')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingFacilityOwner = false;
        if (!response.data || !response.data.data || !response.data.data.fullName) {
          throw new Error("Error retrieving facility's owner.");
        }
        self.facilityOwner = response.data.data.fullName;
      })
      .catch(function (err) {
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingFacilityOwner = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred fetching this facility\'s owner.'
        });
      })
    },
    updateOwner (ownerCandidate: any) {
      this.showDropdown = false;
      let facilityId = (this as any).facilityId;
      let self = this as any;
      let oldOwner = this.facilityOwner;
      self.facilityOwner = ownerCandidate.fullName;
      HTTP.put('/api/facilities/' + facilityId + '/owner', { "newFacilityOwnerId": ownerCandidate.id})
      .then(function (response) {
        if (!response.data.success) {
          self.facilityOwner = oldOwner;
          throw new Error("Error updating Facility's Owner.");
        }
      })
      .catch(function (err) {
        console.log(err);
        self.facilityOwner = oldOwner;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Updating Owner',
          text: 'Please try updating this facility\'s owner again.'
        });
      })
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/facility/facilityComponents/FacilityOwner.vue